import { UnknownAsyncThunkFulfilledAction } from '@reduxjs/toolkit/dist/matchers';
import { selectCourseModules } from 'core/selectors/admin/courseModules';
import { domainRequest } from 'core/services/authentication';
import { all, call, fork, put, select, takeEvery, takeLatest } from 'redux-saga/effects';
import { RootState } from 'types';
import { ICourseDAO } from 'types/domain/course';

// eslint-disable-next-line require-yield
function* newDomainSaga(action: UnknownAsyncThunkFulfilledAction) {
  const arg: any = action.meta.arg;
  const { signInURL } = action.payload as any;
  // const modules = yield select((state: RootState) => selectCourseModules(state, course.id));

  if (signInURL?.length) {
    window.location.replace(signInURL);
  }
}

function* watchDomainRquestFulfilled() {
  yield takeLatest(domainRequest.fulfilled, newDomainSaga);
}

export function* signUpSaga() {
  yield all([fork(watchDomainRquestFulfilled)]);
}
